import { useState, type JSX } from "react";
import { Outlet } from "react-router";

import { AppBreadcrumbs } from "./AppBreadcrumbs.js";
import { AppSidebar } from "./AppSidebar.js";
import { AppTopbar } from "./AppTopbar.js";
import { MobileNavDrawer } from "./MobileNavDrawer.js";

export function AppShell(): JSX.Element {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex h-screen w-full flex-col bg-background">
      <AppTopbar onMenuClick={() => setMobileNavOpen(true)} />
      <div className="app-shell-corner relative flex min-h-0 flex-1">
        <AppSidebar />
        <MobileNavDrawer open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
        <div className="flex min-w-0 flex-1 flex-col">
          <AppBreadcrumbs />
          <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
